if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (this.classList.contains("cb-lightbox")) {
          this.addEventListener("click", (event) => {
            const step = event.target.closest("[data-lightbox-step]");
            if (step) this.stepPhoto(Number(step.dataset.lightboxStep));
            if (
              event.target.closest(
                "[data-lightbox-zoom], .product-media-modal__content > img",
              )
            )
              this.setZoom(!this.classList.contains("is-zoomed"));
          });
          this.addEventListener("keydown", (event) => {
            if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
              if (this.classList.contains("is-zoomed")) return;
              event.preventDefault();
              this.stepPhoto(event.key === "ArrowRight" ? 1 : -1);
            }
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (this.classList.contains("cb-lightbox")) {
          this.displayPhoto(this.openedBy.dataset.mediaId);
          return;
        }
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`,
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`,
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }

      getPhotos() {
        const gallery = document.querySelector(
          `[data-editorial-gallery][data-section="${this.dataset.section}"]`,
        );
        const allowed = gallery?.getEditorialSlides()?.map((slide) => slide.dataset.photoId);
        return [
          ...this.querySelectorAll(
            ".product-media-modal__content > [data-media-id]",
          ),
        ].filter((photo) => !allowed || allowed.includes(photo.dataset.mediaId));
      }

      stepPhoto(delta) {
        const photos = this.getPhotos();
        if (!photos.length) return;
        const index = photos.findIndex((photo) =>
          photo.classList.contains("active"),
        );
        this.displayPhoto(
          photos[(index + delta + photos.length) % photos.length].dataset
            .mediaId,
        );
      }

      displayPhoto(id) {
        const photos = this.getPhotos();
        const active =
          photos.find((photo) => photo.dataset.mediaId === String(id)) ||
          photos[0];
        if (!active) return;
        this.setZoom(false);
        this.querySelectorAll(".product-media-modal__content > [data-media-id]").forEach((photo) =>
          photo.classList.toggle("active", photo === active),
        );
        this.querySelectorAll("[data-lightbox-step], [data-lightbox-count]").forEach((control) => {
          control.hidden = photos.length < 2;
        });
        const slide = document.querySelector(
          `[data-editorial-gallery][data-section="${this.dataset.section}"] [data-photo-id="${active.dataset.mediaId}"]`,
        );
        this.querySelector("[data-lightbox-title]").textContent =
          slide?.dataset.photoTitle || "Methylene Blue";
        this.querySelector("[data-lightbox-count]").textContent =
          `${String(photos.indexOf(active) + 1).padStart(2, "0")} / ${String(photos.length).padStart(2, "0")}`;
      }

      setZoom(zoomed) {
        this.classList.toggle("is-zoomed", zoomed);
        const button = this.querySelector("[data-lightbox-zoom]");
        button.setAttribute("aria-pressed", String(zoomed));
        button.textContent = zoomed ? "Fit image" : "Zoom in";
        const content = this.querySelector(".product-media-modal__content");
        requestAnimationFrame(() => {
          content.scrollLeft = zoomed
            ? (content.scrollWidth - content.clientWidth) / 2
            : 0;
          content.scrollTop = zoomed
            ? (content.scrollHeight - content.clientHeight) / 2
            : 0;
        });
      }
    },
  );
}
